import type React from 'react'
import { Outlet } from 'react-router-dom'
import { useIsSuperAdmin } from '@/domains/shared/hooks/useHasPermission'
import ForbiddenPage from '@/domains/shared/routes/ForbiddenPage'

/**
 * Route guard for the pages that are not behind a catalogue action but behind the
 * SuperAdmin grant (ADR 0020): the Companies page. Same shape as RequirePermission.
 */
export const RequireSuperAdmin: React.FC = () => {
  return useIsSuperAdmin() ? <Outlet /> : <ForbiddenPage />
}
